<template>
  <div :class="classes">
      <pt-page-title title="促销活动审核"></pt-page-title>
      <pt-page-menu-filter :tabs="pageTab" v-model="queryParams.auditStatus">
      </pt-page-menu-filter>
      <pt-promotion-table :labels="labels" :queryParams="queryParams" ref="table">
          <el-table-column label="操作">
            <template slot-scope="scope">
                 <el-button type="text" @click="promotionDetail(scope.row)">详情</el-button>
                <template v-if="HAS_PROMOTION_REVIEW">
                    <el-button v-if="is_WAITING_AUDI(scope.row)" type="text" @click="reviewPass(scope.row)">{{examine(scope.row)}}</el-button>
                    <el-button  v-if="is_WAITING_AUDI(scope.row)" type="text" @click="reviewReject(scope.row)">{{examineReject(scope.row)}}</el-button>
                </template>
                <!-- <template v-else>
                    <el-button type="text" @click="promotionDetail(scope.row)">详情</el-button>
                </template> -->
            </template>
          </el-table-column>
      </pt-promotion-table>
      <el-dialog :visible="is_dialog" :title="dialog_title"  @close="closeDialog" :class="$style['promotion-reject-dialog']">
          <promotion-reject @close="closeDialog" :promotionDetail="promotion"></promotion-reject>
      </el-dialog>
  </div>
</template>

<script>
import promotionReject from './promotion-reject'
import ptPromotionTable from '../pt-promotion-coupon/pt-promotion-table/withData'
import { pageTab, waitApproveTableLabels, approvedTableLabels } from './promotion-review-options.js'
import { hasPermissions } from 'utils/permissions'
const PERM_MALL_PROMOTIONS_APPROVAL = 'PERM_MALL_PROMOTIONS_APPROVAL'// 促销活动审批架权限
// 组件class前缀
const prefixCls = 'pt-promotion-review'

export default {
  name: 'pt-promotion-review',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    is_dialog: {
      set: function (val) {
        this.is_reject = val
      },
      get: function () {
        return this.is_reject
      }
    },
    labels () {
      return this.queryParams.auditStatus === 'UNAUDITED' ? waitApproveTableLabels : approvedTableLabels
    },
    // 是否拥有促销活动上架审核权限
    HAS_PROMOTION_REVIEW () {
      return this.$auth.user() && this.$auth.user().permissions && hasPermissions(this.$auth.user().permissions, PERM_MALL_PROMOTIONS_APPROVAL) &&
      this.queryParams && (this.queryParams.auditStatus === 'UNAUDITED' || this.queryParams.auditStatus === 'WAITING_FINANCIAL_AUDIT')
    }
  },
  components: {
    ptPromotionTable,
    promotionReject
  },
  data () {
    return {
      pageTab: pageTab,
      queryParams: {},
      is_reject: false,
      promotion: {},
      dialog_title: ''
    }
  },
  methods: {
    examine (row) {
      if (row.promotionData.promotionType === 'CASH_BACK' || row.promotionData.promotionType === 'CPS_BIND') {
        if (row.status === 'WAITING_AUDIT') {
          return '客服审核通过'
        } else if (row.status === 'WAITING_FINANCIAL_AUDIT') {
          return '财务审核通过'
        }
      } else {
        return '审核通过'
      }
    },
    examineReject (row) {
      if (row.promotionData.promotionType === 'CASH_BACK' || row.promotionData.promotionType === 'CPS_BIND') {
        if (row.status === 'WAITING_AUDIT') {
          return '客服驳回'
        } else if (row.status === 'WAITING_FINANCIAL_AUDIT') {
          return '财务驳回'
        }
      } else {
        return '驳回'
      }
    },
    // 是否是待审核状态
    is_WAITING_AUDI (row) {
      return (row.status === 'WAITING_AUDIT' || row.status === 'WAITING_FINANCIAL_AUDIT')
    },
    promotionList () {
      let page = this.$refs.table.page
      this.$refs.table.promotionList(page)
    },
    promotionDetail (val) {
      this.$router.push('/promotion-review/propmotion-detail/' + val.id)
    },
    reviewPass (val) {
      // let text=(val.promotionData&&val.promotionData.promotionType === 'CASH_BACK')?:
      this.$confirm('您确定审核通过该促销活动吗', '促销活动审核', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(_ => {
        this.$emit('reviewPass', val)
      })
    },
    reviewReject (val) {
      this.is_reject = true
      this.promotion = val
      this.dialog_title = '驳回促销活动审核'
    },
    closeDialog (val) {
      this.is_dialog = false
      if (val) {
        this.promotionList()
      }
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.promotion-reject-dialog{
    :global
    .el-dialog{
        min-width: 300PX;
        max-width: 500PX;
    }
}
</style>
